import webtraderES from "./locales/es/webtrader_es.json";
import commonsES from "./locales/es/commons_es.json";

export const messages = {
  es: { ...webtraderES, ...commonsES },
};

export const defaultLocale = "es";
